import { StudentDetails } from './student-details';
import { ParentGuardianDetails } from './parent-guardian-details';
import { EnglishProficiencyDetails } from './english-proficiency-details';
import { SchoolProgramPlacementDetails } from './school-program-placement-details';
import { SpecialCircumstances } from './special-circumstances';
import { VisaOshc } from './visa-ohsc';
import { AccommodationWelfareDetails } from './accommodation-welfare-details';
import { Correspondent } from './corresondents';

export class Summary {
    ApplicationId: number;
    ApplicationNumber: string;
    StudentNumber: string;
    ApplicationStatus: string;
    StudentDetails: StudentDetails;
    ParentGuardians: ParentGuardianDetails[];
    EnglishProficiency: EnglishProficiencyDetails;
    SchoolProgram: SchoolProgramPlacementDetails;
    SpecialCircumstances: SpecialCircumstances;
    VisaOshc: VisaOshc;
    Accommodation: AccommodationWelfareDetails;
    Correspondent: Correspondent;
}